<mode-encoding-field-pill
  [field]="field"
  [encoding]="encoding"
  [model]="model"
  [fieldFormatMap]="fieldFormatMap"
  [format]="format"
  [viewName]="viewName"
  [vizToken]="vizToken"
  [chartType]="chartType"
  [binSizeToFieldMap]="binSizeToFieldMap"
  [allowScalars]="allowScalars"
  [allowAggregates]="allowAggregates"
  [allowQuickCalcs]="allowQuickCalcs"
  [allowContinuous]="allowContinuous"
  [allowDiscrete]="allowDiscrete"
  [allowBinned]="allowBinned"
  [canLegendBeSplit]="canLegendBeSplit"
  [hasSplitLegend]="hasSplitLegend"
  [showColorSettings]="showColorSettings"
  [hideAllMenuOptions]="hideAllMenuOptions"
  (update)="onFieldUpdated($event)"
  (remove)="removeField($event)"
  (removeSort)="onRemoveSort($event)"
  (splitLegend)="onSplitLegend($event)"
  (isValidField)="onIsValidField($event)"
  (getBinSize)="onGetBinSize($event)"
></mode-encoding-field-pill>
